import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCLeads(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 2000 2000" fill="none">
            <rect width="2000" height="2000" rx="400" fill="url(#DCLeadsPaint0_linear)" />
            <g filter="url(#DCLeadsFilter0_d)">
                <rect x="362" y="621" width="1226" height="758" rx="100" fill="white" />
            </g>
            <rect
                x="1136"
                y="830"
                width="378"
                height="57"
                rx="28.5"
                fill="#98A4C4"
                fillOpacity="0.15"
            />
            <rect
                x="461"
                y="1211"
                width="378"
                height="57"
                rx="28.5"
                fill="#98A4C4"
                fillOpacity="0.15"
            />
            <rect
                x="1136"
                y="943"
                width="378"
                height="57"
                rx="28.5"
                fill="#98A4C4"
                fillOpacity="0.15"
            />
            <circle cx="967" cy="887" r="455" stroke="black" strokeWidth="41" fillOpacity="0.15" />
            <path
                d="M967 1287.69C745.534 1287.69 566 1108.15 566 886.687H761.5C849.5 886.687 1047.5 825.187 1168 829.187C1264.4 832.387 1341.5 868.854 1368 886.687C1368 1108.15 1188.47 1287.69 967 1287.69Z"
                fill="#F5B656"
            />
            <path
                d="M967 1288C1188.47 1288 1368 1108.47 1368 886.999H1172.5C1084.5 886.999 886.5 825.499 766 829.499C669.6 832.699 592.5 869.166 566 886.999C566 1108.47 745.534 1288 967 1288Z"
                fill="#F7823E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M566 887.686C566.169 1109.01 745.638 1288.37 967 1288.37C1188.36 1288.37 1367.83 1109.01 1368 887.686C1368 1109.15 1188.47 1288.69 967 1288.69C745.534 1288.69 566 1109.15 566 887.686C566 887.686 566 887.686 566 887.686ZM566.266 887.507C593.014 869.61 669.921 833.375 766 830.186C823.032 828.293 898.207 845.51 970.907 864.172C952.422 869.143 933.967 874.283 915.879 879.322C844.499 899.204 778.822 917.499 739.5 917.499C669.289 917.499 599.376 904.072 566.266 887.507Z"
                fill="#E95442"
            />
            <path
                d="M768.383 790.837C768.54 790.927 768.697 791.023 768.854 791.118C772.438 793.299 776.129 795.323 779.915 797.172C780.213 797.307 780.504 797.448 780.802 797.583C782.311 798.302 783.836 798.999 785.373 799.663C785.856 799.87 786.338 800.09 786.826 800.292C788.593 801.034 790.371 801.748 792.177 802.417C792.458 802.518 792.738 802.608 793.019 802.72C794.595 803.294 796.194 803.833 797.798 804.345C798.499 804.575 799.195 804.783 799.896 804.997C801.169 805.385 802.454 805.745 803.744 806.093C804.395 806.267 805.045 806.459 805.707 806.633C807.48 807.077 809.269 807.493 811.07 807.881C811.771 808.027 812.472 808.162 813.179 808.297C814.486 808.55 815.798 808.78 817.122 809.005C817.829 809.123 818.53 809.241 819.237 809.348C821.127 809.629 823.023 809.882 824.942 810.079C825.379 810.129 825.817 810.157 826.254 810.197C827.898 810.348 829.547 810.483 831.207 810.573C831.796 810.607 832.38 810.646 832.969 810.669C835.022 810.764 837.08 810.826 839.156 810.826C841.231 810.826 843.29 810.759 845.337 810.669C845.926 810.646 846.51 810.607 847.104 810.573C848.759 810.478 850.403 810.348 852.046 810.197C852.484 810.157 852.927 810.129 853.359 810.079C855.271 809.882 857.167 809.629 859.058 809.348C859.77 809.241 860.477 809.129 861.184 809.005C862.502 808.78 863.814 808.55 865.121 808.302C865.828 808.162 866.535 808.027 867.247 807.881C869.042 807.498 870.832 807.077 872.599 806.633C873.266 806.464 873.923 806.267 874.59 806.088C875.869 805.739 877.137 805.385 878.393 804.997C879.106 804.783 879.812 804.57 880.514 804.345C882.101 803.833 883.672 803.299 885.231 802.737C885.545 802.619 885.865 802.512 886.179 802.4C887.952 801.731 889.713 801.028 891.457 800.292C891.951 800.09 892.45 799.87 892.944 799.657C894.464 798.999 895.979 798.313 897.471 797.594C897.779 797.453 898.088 797.307 898.391 797.161C900.275 796.245 902.143 795.284 903.983 794.277C903.989 794.272 904 794.266 904.005 794.266C905.84 793.254 907.64 792.209 909.424 791.124C909.592 791.017 909.755 790.916 909.923 790.815C949.088 766.745 975.284 723.349 975.284 673.899C975.295 598.417 914.22 537 839.15 537C764.08 537 703 598.417 703 673.905C703 723.354 729.207 766.762 768.383 790.837Z"
                fill="#E95442"
            />
            <path
                d="M1142.15 788.541C1142.26 788.601 1142.36 788.664 1142.47 788.727C1144.83 790.166 1147.27 791.502 1149.77 792.723C1149.96 792.812 1150.16 792.904 1150.35 792.993C1151.35 793.468 1152.35 793.928 1153.37 794.366C1153.69 794.504 1154.01 794.648 1154.33 794.782C1155.49 795.272 1156.67 795.743 1157.86 796.184C1158.05 796.251 1158.23 796.31 1158.42 796.385C1159.46 796.763 1160.51 797.119 1161.57 797.457C1162.03 797.609 1162.49 797.746 1162.95 797.887C1163.8 798.143 1164.64 798.381 1165.49 798.611C1165.92 798.726 1166.35 798.852 1166.79 798.967C1167.96 799.26 1169.14 799.535 1170.33 799.791C1170.79 799.887 1171.26 799.976 1171.72 800.065C1172.58 800.232 1173.45 800.384 1174.32 800.533C1174.79 800.611 1175.25 800.688 1175.72 800.759C1176.97 800.944 1178.22 801.111 1179.49 801.241C1179.77 801.275 1180.06 801.293 1180.35 801.319C1181.44 801.419 1182.53 801.508 1183.62 801.568C1184.01 801.59 1184.4 801.616 1184.78 801.631C1186.14 801.694 1187.5 801.735 1188.87 801.735C1190.24 801.735 1191.6 801.69 1192.95 801.631C1193.34 801.616 1193.72 801.59 1194.11 801.568C1195.21 801.505 1196.29 801.419 1197.38 801.319C1197.66 801.293 1197.96 801.275 1198.24 801.241C1199.5 801.111 1200.76 800.944 1202 800.759C1202.47 800.688 1202.94 800.614 1203.41 800.533C1204.28 800.384 1205.14 800.232 1206.01 800.069C1206.47 799.976 1206.94 799.887 1207.41 799.791C1208.59 799.538 1209.77 799.26 1210.94 798.967C1211.38 798.856 1211.81 798.726 1212.26 798.607C1213.1 798.377 1213.94 798.143 1214.77 797.887C1215.24 797.746 1215.7 797.605 1216.17 797.457C1217.21 797.119 1218.25 796.767 1219.28 796.396C1219.49 796.318 1219.7 796.247 1219.9 796.173C1221.07 795.732 1222.24 795.268 1223.39 794.782C1223.71 794.648 1224.04 794.504 1224.37 794.363C1225.37 793.928 1226.37 793.476 1227.36 793.001C1227.56 792.908 1227.76 792.812 1227.96 792.715C1229.21 792.11 1230.44 791.476 1231.66 790.812C1231.66 790.808 1231.67 790.804 1231.67 790.804C1232.88 790.137 1234.07 789.447 1235.25 788.73C1235.36 788.66 1235.47 788.593 1235.58 788.526C1261.43 772.639 1278.72 743.997 1278.72 711.358C1278.72 661.538 1238.41 621 1188.86 621C1139.32 621 1099 661.538 1099 711.362C1099 744 1116.3 772.65 1142.15 788.541Z"
                fill="#F5B656"
            />
            <rect
                x="1332.81"
                y="1166.36"
                width="40"
                height="516.526"
                transform="rotate(-51.2407 1332.81 1166.36)"
                fill="#101010"
            />
            <defs>
                <filter
                    id="DCLeadsFilter0_d"
                    x="268"
                    y="571"
                    width="1414"
                    height="946"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="44" />
                    <feGaussianBlur stdDeviation="47" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="DCLeadsPaint0_linear"
                    x1="1092"
                    y1="-243"
                    x2="1000"
                    y2="2926"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#77A4FC" />
                    <stop offset="0.744792" stopColor="#5479FA" />
                </linearGradient>
            </defs>
        </SVGIcon>
    );
}
